import { isEmpty, isString, isBoolean, trim, isArrayLikeObject, isUndefined, isNull } from 'lodash';

const REQUIRED_ERROR_MSG = 'Can\'t be blank.';

const isBlankOrEmpty = val =>
  isNull(val) || isUndefined(val) || (isArrayLikeObject(val) && isEmpty(val)) || (isString(val) && trim(val) === '') || (isBoolean(val) && val !== true);

const validatorMixin = Base => class extends Base {
  static VALIDATIONS = {}

  get valuesForValidation() { return this.state; }
  set errors(errors) { this.setState({ errors }); }

  validate(checks = {}) {
    const validations = isEmpty(checks) ? this.constructor.VALIDATIONS : checks;
    const errors = {};
    Object.keys(validations).forEach((prop) => {
      if (isBlankOrEmpty(this.valuesForValidation[prop])) {
        const msg = isString(validations[prop]) ? validations[prop] : REQUIRED_ERROR_MSG;
        errors[prop] = [msg];
      }
    });
    this.errors = errors;
    return Object.keys(errors).length === 0;
  }
};

export default validatorMixin;



// WEBPACK FOOTER //
// ./client/app/shared/mixins/validator.js